module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/fails.js
// module id = 20
// module chunks = 1 2 3 4